// extracted by mini-css-extract-plugin
export default {"wrapper":"TargetPage_wrapper__MgSfT"};